import { useRouter } from 'next/router';
import { localeConfig } from '@/utils/constants';

export function useLocale() {
  const { asPath } = useRouter();
  return localeConfig.locales.find((l) => asPath.startsWith(`/${l}`)) ?? localeConfig.defaultLocale;
}

export function useIsKorean() {
  return useLocale() === 'ko-KR';
}
